import React from 'react'
import { Route } from 'react-router'
import Account from '../containers/Account'
import App from '../containers/App'
import ChangePassword from '../containers/ChangePassword'
import ForgotPassword from '../containers/ForgotPassword'
import Login from '../containers/Login'
import OurPolicies from '../containers/OurPolicies'
import Policies from '../containers/Policies'
import Quests from '../containers/Quests'
import Quest from '../containers/Quest'
import ResetPassword from '../containers/ResetPassword'
import UnlockAccount from '../containers/UnlockAccount'
import ReviewQueue from '../containers/ReviewQueue'
import TopicClouds from '../containers/TopicClouds'
import ActivityEdit from '../containers/ActivityEdit'
import ActivityAdd from '../containers/ActivityAdd'
import QuestsAdd from '../containers/QuestsAdd'
import NotFound from '../containers/NotFound'
import Error from '../containers/Error'
import Queue from '../containers/Queue'
import MyQuests from '../containers/MyQuests'
import ProductionStatus from '../containers/ProductionStatus'
import MyCourses from '../containers/MyCourses'
import { requireAuthentication } from '../containers/HOC/AuthenticatedComponent'
import { wrapUnauthenticatedComponent } from '../containers/HOC/UnauthenticatedComponent'
import { restrictAccess } from '../containers/HOC/RestrictAccess'
import { restrictRole } from '../containers/HOC/RoleRequiredComponent'
import JourneyDetails from '../components/mycourses/Journey/JourneyDetails'
import ActivityDetails from '../components/mycourses/Activities/ActivityDetails'

export default (
  <Route path="/" component={App}>
    <Route path="account" component={requireAuthentication(Account)} />
    <Route
      path="changepassword"
      component={wrapUnauthenticatedComponent(ChangePassword)}
    />
    <Route
      path="myquests"
      component={requireAuthentication(restrictAccess(MyQuests))}
    />
    <Route path="login" component={wrapUnauthenticatedComponent(Login)} />
    <Route path="ourpolicies" component={requireAuthentication(OurPolicies)} />
    <Route path="policies" component={Policies} />
    <Route
      path="productionstatus"
      component={requireAuthentication(restrictAccess(ProductionStatus))}
    />
    <Route
      path="quests"
      component={requireAuthentication(restrictAccess(Quests))}
    />
    <Route
      path="mycourses"
      component={requireAuthentication(restrictAccess(MyCourses))}
    />
    <Route
      path="mycourses/:courseId/journey/:journeyId"
      component={requireAuthentication(JourneyDetails)}
    />
    <Route
      path="mycourses/:courseId/journey/:journeyId/level/:levelId/activityQuest/:activityQuestId"
      component={requireAuthentication(ActivityDetails)}
    />
    <Route
      path="mycourses/:courseId/journey/:journeyId/level/:levelId/activityQuest/:activityQuestId/edit"
      component={requireAuthentication(ActivityDetails)}
    />
    <Route
      path="quest/:id/activities/add"
      component={requireAuthentication(restrictRole(ActivityAdd))}
    />
    <Route
      path="quest/:id(/:section)(/:activityId)"
      component={requireAuthentication(Quest)}
    />
    <Route
      path="resetpassword/:token"
      component={wrapUnauthenticatedComponent(ResetPassword)}
    />
    <Route
      path="unlockaccount/:token"
      component={wrapUnauthenticatedComponent(UnlockAccount)}
    />
    <Route
      path="reviewqueue"
      component={requireAuthentication(restrictAccess(ReviewQueue))}
    />
    <Route
      path="queue"
      component={requireAuthentication(restrictAccess(Queue))}
    />
    <Route
      path="topicclouds"
      component={requireAuthentication(restrictAccess(TopicClouds))}
    />
    <Route
      path="quest/:id/activities/:activityId/edit"
      component={requireAuthentication(ActivityEdit)}
    />
    <Route
      path="quests/add"
      component={requireAuthentication(restrictAccess(QuestsAdd))}
    />
    <Route
      path="forgotpassword"
      component={wrapUnauthenticatedComponent(ForgotPassword)}
    />
    <Route path="error" component={requireAuthentication(Error)} />
    <Route path="*" component={requireAuthentication(NotFound)} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/index.js